import axios from 'axios';

import type { UefatvAuthResponse } from '@shared-types/uefatv.types';
import IdpHandler from '@user/IdpHandler';
import { uefaTvApiKey, uefaTvApiUrl, uefaTvRealm } from '@utilities/WindowContext';
const HEADERS = {
  'Content-Type': 'application/json',
  'x-api-key': `${uefaTvApiKey}`,
  Realm: uefaTvRealm,
} as const;

export const bearerTokenName = 'uefatv.authorisationToken' as const;
export const refreshTokenName = 'uefatv.refreshToken' as const;
export const tokenTypeName = 'uefatv.tokenType' as const;

export const getStoredTokens = async () => {
  const idp = await IdpHandler.waitIdpReady();
  if (
    (idp.isLogged() && localStorage.getItem(tokenTypeName) !== 'logged') ||
    (!idp.isLogged() && localStorage.getItem(tokenTypeName) !== 'guest')
  ) {
    localStorage.removeItem(bearerTokenName);
    localStorage.removeItem(refreshTokenName);
    localStorage.removeItem(tokenTypeName);

    return {
      authorisationToken: null,
      refreshToken: null,
      tokenType: null,
    };
  }

  return {
    authorisationToken: localStorage.getItem(bearerTokenName),
    refreshToken: localStorage.getItem(refreshTokenName),
    tokenType: localStorage.getItem(tokenTypeName) as 'guest' | 'logged',
  };
};

export const clearStoredTokens = () => {
  localStorage.removeItem(bearerTokenName);
  localStorage.removeItem(refreshTokenName);
  localStorage.removeItem(tokenTypeName);
};

export const setStoredTokens = (authorisationToken: string, refreshToken: string, tokenType: 'guest' | 'logged') => {
  localStorage.setItem(bearerTokenName, authorisationToken);
  localStorage.setItem(refreshTokenName, refreshToken);
  localStorage.setItem(tokenTypeName, tokenType);
};
export const fetchRefreshToken = async (refreshToken: string, bearerToken: string) => {
  const response = await axios.post<{ refreshToken: string }, { data: UefatvAuthResponse }>(
    `${uefaTvApiUrl}/v2/token/refresh`,
    { refreshToken },
    {
      headers: { ...HEADERS, Authorization: `Bearer ${bearerToken}` },
    },
  );
  return response;
};
export const fetchGuestToken = async () => {
  return await axios.post<unknown, { data: UefatvAuthResponse }>(
    `${uefaTvApiUrl}/v2/login/guest/checkin`,
    {},
    {
      headers: HEADERS,
    },
  );
};
export const fetchJwtTokens = async (jwt: string) => {
  return await await axios.post<{ jwt: string }, { data: UefatvAuthResponse }>(
    `${uefaTvApiUrl}/v2/user/gigya/jwt`,
    { jwt },
    {
      headers: HEADERS,
    },
  );
};
